import { FC, ReactElement, useEffect } from 'react'

import { DeleteChangeLogEntryForm } from '../../../containers/@forms/DeleteChangeLogEntryForm/DeleteChangeLogEntryForm'
import trans from '../../../helpers/trans'
import { deleteChangeLogEntry } from '../../../redux/changeLogEntry/changeLogEntryActions'
import { setIsSuccessful } from '../../../redux/changeLogEntry/changeLogEntryReducer'
import { useTypedDispatch, useTypedSelector } from '../../../redux/store'
import { setToast } from '../../../redux/toasts/toastsReducer'
import { ToastType } from '../../../types'

interface ConnectedDeleteChangeLogEntryFormProps {
    changeLogEntryId: string
    onClose: () => void
}

export const ConnectedDeleteChangeLogEntryForm: FC<ConnectedDeleteChangeLogEntryFormProps> = ({
    changeLogEntryId,
    onClose,
}): ReactElement => {
    const dispatch = useTypedDispatch()
    const { isLoading, isSuccessful } = useTypedSelector(state => state.changeLogEntryReducer)

    const handleDeleteChangeLogEntryClick = (formData: { id: string }): void => {
        dispatch(deleteChangeLogEntry(formData.id))
    }

    useEffect(() => {
        if (isSuccessful) {
            dispatch(setIsSuccessful(false))

            dispatch(setToast({
                text: trans('containers.forms.deleteChangeLogEntryForm.deleteChangeLogEntrySuccess'),
                type: ToastType.pass,
            }))

            onClose()
        }
    }, [isSuccessful])

    return (
        <DeleteChangeLogEntryForm
            isLoading={isLoading}
            changeLogEntryId={changeLogEntryId}
            onSubmit={handleDeleteChangeLogEntryClick}
            onCancel={onClose}
        />
    )
}
